module.exports = __webpack_public_path__ + "img/col-wechat.70610cad.png";